export const iconFontAwesomeMapsBath = (
	<i className="fa-solid fa-bath"></i>
);
